import cn from 'classnames'
import React, { ComponentProps } from 'react'

export type CloudKeySvgProps = {
  className?: string
} & ComponentProps<'svg'>

export default function CloudKeySvg(props: CloudKeySvgProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('CloudKeySvg', className)}
      width="246"
      height="172"
      viewBox="0 0 246 172"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g filter="url(#filter0_d_22542_124272)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.4667 142.175C18.7752 142.175 2 125.369 2 104.639C2 83.9086 18.7752 67.1062 39.4667 67.1062C41.0035 67.1062 42.5089 67.2241 43.9986 67.4047C43.1989 63.7599 42.752 59.9815 42.752 56.0932C42.752 26.9542 66.3289 3.3335 95.4139 3.3335C121.139 3.3335 142.521 21.8208 147.127 46.2467C150.561 44.7188 154.356 43.8508 158.359 43.8508C172.221 43.8508 183.673 54.0626 185.711 67.3812C204.337 69.5531 218.803 85.3932 218.803 104.639C218.803 125.369 202.028 142.175 181.336 142.175H39.4667Z"
          fill="#BFDEF3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.4142 155.782C26.7227 155.782 9.94751 138.976 9.94751 118.246C9.94751 97.516 26.7227 80.7136 47.4142 80.7136C48.951 80.7136 50.4564 80.8315 51.9462 81.0122C51.1464 77.3673 50.6995 73.589 50.6995 69.7006C50.6995 40.5616 74.2764 16.9409 103.361 16.9409C129.087 16.9409 150.468 35.4282 155.075 59.8541C158.509 58.3262 162.304 57.4582 166.306 57.4582C180.169 57.4582 191.62 67.67 193.659 80.9886C212.284 83.1606 226.75 99.0006 226.75 118.246C226.75 138.976 209.975 155.782 189.284 155.782H47.4142Z"
          fill="#223C66"
          fillOpacity="0.2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M55.9972 156.48C35.3057 156.48 18.5305 139.674 18.5305 118.944C18.5305 98.2138 35.3057 81.4114 55.9972 81.4114C57.534 81.4114 59.0394 81.5292 60.5292 81.7099C59.7294 78.0651 59.2825 74.2867 59.2825 70.3984C59.2825 41.2594 82.8594 17.6387 111.944 17.6387C137.67 17.6387 159.051 36.126 163.658 60.5518C167.092 59.024 170.887 58.156 174.89 58.156C188.752 58.156 200.203 68.3678 202.242 81.6863C220.867 83.8583 235.333 99.6984 235.333 118.944C235.333 139.674 218.558 156.48 197.867 156.48H55.9972Z"
          fill="#223C66"
        />
        <path
          d="M166.766 148.188C174.351 159.944 190.001 167.61 207.45 160.577C214.933 157.562 220.995 151.592 224.071 144.201C225.932 139.734 226.872 135.155 226.872 130.575C226.872 112.574 212.224 97.9258 194.223 97.9258C182.989 97.9258 172.736 103.609 166.756 112.952L98.5025 112.952L81.6667 129.829L100.721 148.883L107.028 142.576L113.335 148.883L119.662 142.556L125.98 148.873L132.287 142.566L137.899 148.178L166.776 148.178L166.766 148.188Z"
          fill="white"
        />
        <path
          d="M152.187 143.096L170.737 143.096C176.717 154.786 190.957 161.556 205.787 155.586C211.857 153.136 216.777 148.326 219.297 142.276C227.437 122.686 213.267 103.926 194.717 103.926C184.247 103.926 175.197 109.906 170.737 118.626L103.147 118.626L91.6668 130.136L97.0168 135.486L103.247 141.716L109.417 135.546L115.587 141.716L121.777 135.526L127.957 141.706L134.127 135.536L141.687 143.096L152.187 143.096ZM200.737 134.786C196.937 128.076 203.797 121.206 210.507 125.016C211.307 125.466 211.977 126.146 212.427 126.936C216.227 133.646 209.367 140.516 202.657 136.706C201.857 136.256 201.187 135.576 200.737 134.786Z"
          fill="url(#paint0_linear_22542_124272)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_22542_124272"
          x="0"
          y="0.00016284"
          width="245.333"
          height="171.936"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" dy="2.66667" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_22542_124272"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_22542_124272"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_22542_124272"
          x1="250.104"
          y1="165.274"
          x2="52.9981"
          y2="92.2481"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#01D0B4" />
          <stop offset="1" stopColor="#468BF9" />
        </linearGradient>
      </defs>
    </svg>
  )
}
